import ApiService from "@/core/services/api.service";
// action types
export const PAGINATION_RECEIPT_TYPE = "paginationReceiptType";
export const GET_RECEIPT_TYPE = "getReceiptType";
export const FIND_RECEIPT_TYPE = "findReceiptType";
export const CREATE_RECEIPT_TYPE = "createReceiptType";
export const UPDATE_RECEIPT_TYPE = "updateReceiptType";
export const DELETE_RECEIPT_TYPE = "deleteReceiptType";
// mutation types
export const SET_PAGINATION = "setPagination";
export const SET_IS_CLEAR_PAGINATION = "setIsClearPagination";
export const CLEAR_PAGINATION = "clearPagination";

export default {
  state: {
    path: "receipt_type",
    isClearPagination: true,
    pagination: {
      page: 1,
      perPage: 25,
      orderBy: "id",
      isDesc: true,
      sortDirection: "asc",
      filter: ""
    }
  },
  getters: {},
  actions: {
    [PAGINATION_RECEIPT_TYPE](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}/pagination`, {
        params: payload.params
      });
    },
    [GET_RECEIPT_TYPE](context) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}`);
    },
    [FIND_RECEIPT_TYPE](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}/${payload.id}`, null);
    },
    [CREATE_RECEIPT_TYPE](context, payload) {
      ApiService.setHeader();
      return ApiService.post(`${context.state.path}`, payload.data);
    },
    [UPDATE_RECEIPT_TYPE](context, payload) {
      ApiService.setHeader();
      return ApiService.put(
        `${context.state.path}/${payload.id}`,
        payload.data
      );
    },
    [DELETE_RECEIPT_TYPE](context, payload) {
      ApiService.setHeader();
      return ApiService.delete(`${context.state.path}/${payload.id}`);
    }
  },
  mutations: {
    [SET_PAGINATION](state, payload) {
      state.pagination = payload.pagination;
    },
    [SET_IS_CLEAR_PAGINATION](state, payload) {
      state.isClearPagination = payload.isClearPagination;
    },
    [CLEAR_PAGINATION](state) {
      state.pagination = {
        page: 1,
        perPage: 25,
        orderBy: "id",
        isDesc: true,
        sortDirection: "asc",
        filter: ""
      };
    }
  }
};
